// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"style_preview-wrapper__8twm9","message-container":"style_message-container__6mXSu"};